import { render, staticRenderFns } from "./service-course-card.vue?vue&type=template&id=6cfbc667&scoped=true"
import script from "./service-course-card.vue?vue&type=script&lang=js"
export * from "./service-course-card.vue?vue&type=script&lang=js"
import style0 from "./service-course-card.vue?vue&type=style&index=0&id=6cfbc667&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfbc667",
  null
  
)

export default component.exports